import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeOption: {
		id: 'servicedesk-customers-organization-common.common.editable-table.editor-cell.remove-option',
		defaultMessage: 'Remove {name}.',
		description: 'Remove selected option',
	},
});
